import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Entity } from './entities';

/**
 * Firest when a widget is presented to the user
 */
export interface WidgetView {}

export const widgetView = (data: WidgetView, context?: Entity[]) =>
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/widget_view/jsonschema/1-0-0', data },
    context
  });
